import React, { useState } from 'react';
import { supabase } from './supabaseClient';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();

    try {
      const { data: user, error } = await supabase.auth.signUp({
        email,
        password,
      });

      if (error) throw error;

      // Add user to the 'users' table
      const { error: dbError } = await supabase.from('users').insert([
        { email, password, auctions_created: 0, auction_codes: [] },
      ]);

      if (dbError) throw dbError;

      setSuccess('Signup successful! Please log in.');
    } catch (err) {
      setError(err.message || 'Error signing up.');
    }
  };

  return (
    <div>
      <h1>Signup</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {success && <p style={{ color: 'green' }}>{success}</p>}
      <form onSubmit={handleSignup}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Sign Up</button>
      </form>
    </div>
  );
};

export default Signup;
